module.exports = __webpack_public_path__ + "static/benef4_bleu-40ae22e5d6632ca8cc4e5d55ec53ea5a.jpg";